import * as React from 'preact/compat'
import type { ComponentChild } from 'preact'

import SVG from '#components/SVG'
import type { SearchItemProps } from '#components/Search/SearchPanel'

import styles from '#css/search-panel.pcss.json'

export default ({ item }: SearchItemProps) => {
    let ratingPrefix = ''
    let inTeam: ComponentChild = ''

    const ratingClasses: string[] = [styles['user-card__rating']]
    let avatar = <div className={`${styles['user-card__avatar']} ${styles['user-card__avatar--empty']}`}>
        <svg viewBox="0 0 43 38">
            <path d="M32 0H18c-2.2.4-2.4 2.9-2.7 4.6h18.1l.5-3c0-.9-1-1.6-1.9-1.6zM21.4 10H15c-.5-.2-.8.3-.9.7l-1 5.7 20 .1c1.4 0 2.5 1.5 2.2 3L34 28h4c1.3-.1 2.2-1.4 2.4-2.6l2.3-13c.1-.7.2-1.5-.4-2-.5-.6-1.3-.6-2-.6h-19zM6 10H4.9c-1.3 0-2.3 1.3-2.5 2.5L0 26c-.2 1.1.8 2.2 2 2 8.5.1 17 0 25.6 0 .4.1 1 0 1-.5.5-1.9.7-3.8 1.1-5.7H11.8c-1.2-.1-2.5.2-3.5-.6-.8-.6-1-1.8-.8-2.8L9.3 10H6zm12.9 23.4h-9c-.2.9-.4 1.8-.4 2.7.2.9 1 1.5 2 1.4h12.8c.8 0 1.7 0 2.4-.6 1-.9 1-2.3 1.2-3.5h-9z" fill="currentColor"/>
        </svg>
    </div>

    if (item.rating > 0) {
        ratingPrefix = '+'
        ratingClasses.push(styles['user-card__rating--plus'])
    } else if (item.rating < 0) {
        ratingPrefix = '-'
        ratingClasses.push(styles['user-card__rating--minus'])
    }

    if (item.inTeam) {
        inTeam = <div className={styles['user-card__in-team']}><SVG i='sg/logo-small' /></div>
    }

    if (item.avatar) {
        avatar = <img alt='' src={item.avatar} className={styles['user-card__avatar']} />
    }

    return <a href={item.url} className={styles['user-card']} data-user-info={true}>
        {item.poster ? <img alt='' src={item.poster} className={styles['user-card__poster']} data-user-info-image={true} /> : <div class={styles['user-card__poster']} />}
        <div className={styles['user-card__top']}>
            <div className={styles['user-card__avatar-container']}>
                {avatar}
                {inTeam}
            </div>
            <div className={ratingClasses.join(' ')}>{ratingPrefix}{item.rating}</div>
        </div>
        <h3 className={styles['user-card__title']} data-user-info-name={true}>{item.isBanned ? <s>{item.title}</s> : item.title}</h3>
        <div className={styles['user-card__bottom']}>
            <span className={styles['user-card__date']}>
                На сайте<span className={styles['user-card__date--desktop']}>:<br/></span>
                <span className={styles['user-card__date--mobile']}> </span>с {item.date}
            </span>
            <div className={styles['user-card__comments']}>
                <SVG i='sg-new/comments' adaptive />
                {item.comments}
            </div>
        </div>
    </a>
}
